import { observable, decorate, action } from 'mobx'
import axios from 'axios'

class ProductsStore {
  constructor () {
    this.state = {
      products: [],
      isFetching: false,
      activeProduct: null
    }
    this.fetchAllProducts()
  }

  fetchAllProducts () {
    this.state.isFetching = true
    const url = process.env.REACT_APP_AWS_URL + '/getAllProducts'
    axios.get(url)
      .then(response => {
        this.state.products = response.data
        this.state.isFetching = false
      })
      .catch(error => {
        console.log(error)
        this.state.isFetching = false
      })
  }

  changeActiveProduct (name, uiStore) {
    this.state.activeProduct = this.state.products.find(product => product.name === name)
    uiStore.changeActiveItem(name)
  }
}

decorate(ProductsStore, {
  state: observable,
  fetchAllProducts: action,
  changeActiveProduct: action
})

export default ProductsStore



// WEBPACK FOOTER //
// ./src/stores/productsStore.js